var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app-bar',{attrs:{"app":"","color":"primary","dark":""}},[_c('BotaoDeDrawer'),_c('v-toolbar-title',[_vm._v(" "+_vm._s(_vm.titulo)+" ")]),_c('v-spacer'),_c('IconesDaToolbarPadroes')],1)}
var staticRenderFns = []

export { render, staticRenderFns }